import { computed } from 'vue'

export function usePreviousRoute(router) {
  const previousRoute = computed(() => {
    const backUrl = router.options.history.state.back
    return router.resolve({ path: `${backUrl}` })
  })

  return { previousRoute }
}
